import { Component, OnInit, Input } from '@angular/core';
import { SmartFormLibService } from './smart-form-lib.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'csf-smart-form-lib',
  template: `
  <div *ngIf="sFlow!=undefined">
    <div style="align-content: center;text-align: center;">
        <ul class="step">
            <li *ngFor="let step of sfSteps;" class="step-item" [ngClass]="{'active':step.stepIndex == activeIx}">
                <a class="tooltip" (click)="selectStep(step.stepIndex)" [attr.data-tooltip]="step.description">{{step.name}}</a>
            </li>
        </ul>
    </div>    
    <div class="container" *ngIf="sfNode!=undefined">        
        <div *ngFor="let item of sfNode.editable | keyvalue; let i = index">          
            <div class="columns" style="padding:10px;">
                <div class="column col-12" style="text-align: center;">
                    <u><small><b>{{sfNode.name}}</b></small></u>&nbsp;&nbsp;&nbsp; <i><small>{{sfNode.description}}</small></i>
                </div>
            </div>            
            <csf-input-control *ngIf="item.value.type!='audio'" [i]="i" [item]="item" [node]="sFlow.nodes[activeIx]"></csf-input-control>
            <csf-audio-control *ngIf="item.value.type=='audio'" [i]="i" [item]="item" [node]="sFlow.nodes[activeIx]"></csf-audio-control>
        </div>
    </div>
  </div>
  `,
  styles: []
})
export class SmartFormLibComponent implements OnInit {

  sFlow:any;
  sfNode:any;
  sfSteps:Array<any>=[];
  activeIx:number = 0;
  constructor(private dataService:SmartFormLibService) { }

  private _flowId: string;
  @Input()
  set flowId(flowId: string) {
    this._flowId = flowId;
    this.activeIx = 0;
    this.sfSteps = [];
    this.sFlow=undefined;
    this.sfNode=undefined;
    this.getFlow();
  }
  get flowId(): string {
    return this._flowId;     
  }

  private _accessCode: string;
  @Input()
  set accessCode(code: string) {
    this._accessCode = code;
    this.getFlow();
  }
  get accessCode(): string {
    return this._accessCode;     
  }

  @Input()
  update:boolean = false;

  @Input()
  origin:string = "ENG";

  ngOnInit() {
  }

  getFlow(){
    if(this.flowId!=undefined){
      this.dataService.getFlow(this.flowId).subscribe((data)=>{        
        this.sFlow = data;
        if(this.sFlow != undefined){
          if(this.sFlow.nodes.length>0){
            let i = 0;
            for(let eNode of this.sFlow.nodes){
              if(eNode.editable!=undefined && Object.keys(eNode.editable).length>0){
                let sfStep = {stepIndex: i, name: eNode.name, description: eNode.description};
                this.sfSteps.push(sfStep);
              }
              i++;
            }
          }
          if(this.sfSteps.length>0){
            this.activeIx = this.sfSteps[0].stepIndex;
            this.sfNode = this.sFlow.nodes[this.activeIx];
          }
        }
      });
    }
  }

  selectStep(i){
    this.activeIx = i;
    this.sfNode = this.sFlow.nodes[this.activeIx];
  }

  public saveFlow(): Observable<any>{
    if(this.sFlow!=undefined){
      if(!this.update) {
        delete this.sFlow.id;
        this.sFlow.flowId = -1;
      }
      this.sFlow.origin = this.origin;
      return this.dataService.deployFlow(this.sFlow, this.accessCode);
    }
  }

}
